<div *ngIf="loading" style="display: flex; flex-direction: column; height: 100%">
  <mat-spinner style="margin: auto;" [diameter]="48" mode="indeterminate"></mat-spinner>
</div>
<img *ngIf="data[this.key] != null" style="max-width: calc(100%); max-height: calc(100% - 4em)" [src]="'data:image/PNG;base64,' + data[this.key]"/>
